<template>
  <div ref="container" id="fit-finder-container" />
</template>

<script lang="ts" setup>
const container = ref<HTMLElement | null>(null)

const {
  showFitRating,
  showModelMeasurements,
  showSizeChart,
  hasFitFinderContent
} = usePdp()

const shouldSkipFitFinderObserver = computed(() =>
  showFitRating.value
  || showModelMeasurements.value
  || showSizeChart.value
)

onMounted(() => {
  if (shouldSkipFitFinderObserver.value || !container.value) return

  // Check immediately to avoid observing unnecessarily
  if (container.value.innerHTML?.trim().length > 0) {
    hasFitFinderContent.value = true
  }

  const { stop } = useMutationObserver(
    container,
    () => {
      const html = container.value?.innerHTML?.trim() || ''
      if (html.length > 0) {
        hasFitFinderContent.value = true
        stop()
      }
    },
    {
      childList: true
    }
  )
})
</script>
